import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  verifyMedicationCode: {
    loading: false,
    error: null,
    data: null,
    success: false,
  },
  stateList: {
    data: [],
    loading: false,
    error: null,
    success: false,
  },
  cityList: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
    success: false,
  },
  doctorCityList: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
    success: false,
  },
  hospitalsInCityList: {
    data: [],
    loading: false,
    error: null,
    success: false,
  },
  doctorsListInHospitalList: {
    data: [],
    loading: false,
    error: null,
    success: false,
  },
  addDoctor: {
    data: [],
    loading: false,
    error: null,
    success: false,
  },
  addHospital: {
    data: [],
    loading: false,
    error: null,
    success: false,
  },
}

const carePlanSlice = createSlice({
  name: 'carePlan',
  initialState,
  reducers: {
    verifyMedicationCodeRequest: (state) => {
      state.verifyMedicationCode.loading = true
      state.verifyMedicationCode.error = null
      state.verifyMedicationCode.data = null
      state.verifyMedicationCode.success = false
    },
    verifyMedicationCodeSuccess: (state, action) => {
      state.verifyMedicationCode.loading = false
      state.verifyMedicationCode.data = action.payload
      state.verifyMedicationCode.error = null
      state.verifyMedicationCode.success = true
    },
    verifyMedicationCodeFailure: (state, action) => {
      state.verifyMedicationCode.loading = false
      state.verifyMedicationCode.error = action.payload.message
      state.verifyMedicationCode.data = action.payload.data
      state.verifyMedicationCode.success = false
    },
    resetVerifyCodeData: (state, action) => {
      state.verifyMedicationCode.loading = false
      state.verifyMedicationCode.error = null
      state.verifyMedicationCode.data = null
      state.verifyMedicationCode.success = false
    },

    // state list
    getStateListRequest: (state, action) => {
      state.stateList.loading = true
      state.stateList.data = []
      state.stateList.error = null
      state.stateList.success = false
    },
    getStateListSuccess: (state, action) => {
      state.stateList.loading = false
      state.stateList.data = action.payload
      state.stateList.error = null
      state.stateList.success = true
    },
    getStateListError: (state, action) => {
      state.stateList.loading = false
      state.stateList.data = []
      state.stateList.error = action.payload
      state.stateList.success = false
    },

    // city list
    getCityListByStateRequest: (state, action) => {
      state.cityList.loading = true
      state.cityList.data = []
      state.cityList.pagination = {}
      state.cityList.error = null
      state.cityList.success = false
    },
    getCityListByStateSuccess: (state, action) => {
      state.cityList.loading = false
      state.cityList.data = action.payload?.data
      state.cityList.pagination = action.payload?.pagination
      state.cityList.error = null
      state.cityList.success = true
    },
    getCityListByStateError: (state, action) => {
      state.cityList.loading = false
      state.cityList.data = []
      state.cityList.pagination = {}
      state.cityList.error = action.payload
      state.cityList.success = false
    },

    // doctor city list
    getDoctorCityListRequest: (state, action) => {
      const isLoadMore = action.payload?.isLoadMore
      state.doctorCityList = {
        ...state.doctorCityList,
        loading: true,
        data: isLoadMore ? state.doctorCityList.data : [],
        pagination: isLoadMore ? state.doctorCityList.pagination : {},
        error: null,
        success: false,
      }
    },
    getDoctorCityListSuccess: (state, action) => {
      const isLoadMore = action.payload?.isLoadMore
      state.doctorCityList = {
        ...state.doctorCityList,
        loading: false,
        data: isLoadMore
          ? [...state.doctorCityList.data, ...action.payload.data]
          : action.payload.data,
        pagination: action.payload.pagination,
        error: null,
        success: true,
      }
    },
    getDoctorCityListError: (state, action) => {
      state.doctorCityList = {
        ...state.doctorCityList,
        loading: false,
        error: action.payload,
        success: false,
      }
    },

    // hospitals in city list
    getHospitalsInCityListRequest: (state, action) => {
      const isLoadMore = action.payload?.isLoadMore
      state.hospitalsInCityList = {
        ...state.hospitalsInCityList,
        loading: true,
        data: isLoadMore ? state.hospitalsInCityList.data : [],
        error: null,
        success: false,
      }
    },
    getHospitalsInCityListSuccess: (state, action) => {
      const isLoadMore = action.payload?.isLoadMore
      const incomingData = action.payload?.data || []
      state.hospitalsInCityList = {
        ...state.hospitalsInCityList,
        loading: false,
        data: isLoadMore
          ? [...state.hospitalsInCityList.data, ...incomingData]
          : incomingData,
        error: null,
        success: true,
      }
    },
    getHospitalsInCityListError: (state, action) => {
      state.hospitalsInCityList = {
        ...state.hospitalsInCityList,
        loading: false,
        data: [],
        error: action.payload,
        success: false,
      }
    },

    // doctors list in hospital list
    getDoctorsListInHospitalListRequest: (state, action) => {
      const isLoadMore = action.payload?.isLoadMore
      state.doctorsListInHospitalList = {
        ...state.doctorsListInHospitalList,
        loading: true,
        data: isLoadMore ? state.doctorsListInHospitalList.data : [],
        error: null,
        success: false,
      }
    },
    getDoctorsListInHospitalListSuccess: (state, action) => {
      const isLoadMore = action.payload?.isLoadMore
      const incomingData = action.payload?.data || []
      state.doctorsListInHospitalList = {
        ...state.doctorsListInHospitalList,
        loading: false,
        data: isLoadMore
          ? [...state.doctorsListInHospitalList.data, ...incomingData]
          : incomingData,
        error: null,
        success: true,
      }
    },
    getDoctorsListInHospitalListError: (state, action) => {
      state.doctorsListInHospitalList = {
        ...state.doctorsListInHospitalList,
        loading: false,
        data: [],
        error: action.payload,
        success: false,
      }
    },

    // add doctor
    addDoctorRequest: (state, action) => {
      state.addDoctor = {
        ...state.addDoctor,
        loading: true,
        data: [],
        error: null,
        success: false,
      }
    },
    addDoctorSuccess: (state, action) => {
      state.addDoctor = {
        ...state.addDoctor,
        loading: false,
        data: action.payload,
        error: null,
        success: true,
      }
    },
    addDoctorError: (state, action) => {
      state.addDoctor = {
        ...state.addDoctor,
        loading: false,
        data: [],
        error: action.payload,
        success: false,
      }
    },

    // add hospital
    addHospitalRequest: (state, action) => {
      state.addHospital = {
        ...state.addHospital,
        loading: true,
        data: [],
        error: null,
        success: false,
      }
    },
    addHospitalSuccess: (state, action) => {
      state.addHospital = {
        ...state.addHospital,
        loading: false,
        data: action.payload,
        error: null,
        success: true,
      }
    },
    addHospitalError: (state, action) => {
      state.addHospital = {
        ...state.addHospital,
        loading: false,
        data: [],
        error: action.payload,
        success: false,
      }
    },
  },
})

export const {
  verifyMedicationCodeRequest,
  verifyMedicationCodeSuccess,
  verifyMedicationCodeFailure,
  resetVerifyCodeData,
  // state list
  getStateListRequest,
  getStateListSuccess,
  getStateListError,

  // city list
  getCityListByStateRequest,
  getCityListByStateSuccess,
  getCityListByStateError,

  // doctor city list
  getDoctorCityListRequest,
  getDoctorCityListSuccess,
  getDoctorCityListError,

  // hospitals in city list
  getHospitalsInCityListRequest,
  getHospitalsInCityListSuccess,
  getHospitalsInCityListError,

  // doctors list in hospital list
  getDoctorsListInHospitalListRequest,
  getDoctorsListInHospitalListSuccess,
  getDoctorsListInHospitalListError,

  // add doctor
  addDoctorRequest,
  addDoctorSuccess,
  addDoctorError,

  // add hospital
  addHospitalRequest,
  addHospitalSuccess,
  addHospitalError,
} = carePlanSlice.actions

export default carePlanSlice.reducer
